import React from 'react';
import { atsIntegrations } from './data/atsIntegrationsData';
import LogoCarousel from './LogoCarousel';

const ATSIntegrationsSection: React.FC = () => {
  return (
    <div className="mt-16 pt-8 border-t border-gray-100">
      <h3 className="text-2xl md:text-3xl font-bold text-center mb-8 text-gradient">
        Integraciones ATS
      </h3>
      <div className="w-full overflow-hidden">
        <LogoCarousel 
          clients={atsIntegrations} 
          grayscale={true} 
          speed={1}
          direction="right" 
          className="py-4"
        />
      </div>
    </div>
  );
};

export default ATSIntegrationsSection;